export enum EDegradedMode {
  OK = "ok",
  PAUSED = "paused",
  CANCELLED = "cancelled",
  UNKNOWN = "unknown",
}

export const degradedModeAsString = (mode: EDegradedMode | string): string => {
  switch (mode) {
    case EDegradedMode.OK:
      return "Actif";
    case EDegradedMode.PAUSED:
      return "Suspendu";
    case EDegradedMode.CANCELLED:
      return "Résilié";
    case EDegradedMode.UNKNOWN:
    default:
      return "Inconnu";
  }
};

